import React, {useState} from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

const PREFIX = 'UserTransferList';

const classes = {
  root: `${PREFIX}-root`,
  paper: `${PREFIX}-paper`,
  button: `${PREFIX}-button`
};

const StyledGrid = styled(Grid)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    margin: 'auto',
  },

  [`& .${classes.paper}`]: {
    width: 460,
    height: 300,
    overflow: 'auto',
  },

  [`& .${classes.button}`]: {
    margin: theme.spacing(0.5, 0),
  }
}));

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export default function UserTransferList({formValues, setFormValues, userList}) {

  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState(Object.keys(userList).map(k=>parseInt(k)).filter((k)=> !formValues.users.includes(k)));
  const [right, setRight] = useState(formValues.users);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const sortUsers=(a,b)=>{
    let user_a=userList[a].userAccount.toLowerCase();
    let user_b=userList[b].userAccount.toLowerCase();
    return user_a<user_b ? -1 : user_a>user_b ? 1: 0;
  };

  const handleToggle=(value)=>()=>{
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight=()=>{
    setLeft([]);
    let newRight = [...right, ...left];
    setRight(newRight);
    setChecked(not(checked, leftChecked));
    let newVals = {...formValues};
    newVals["users"]=newRight;
    setFormValues(newVals);
  };

  const handleCheckedToRight=()=>{
    setLeft(not(left, leftChecked));
    let rightVal = [...right, ...leftChecked];
    setRight(rightVal);
    setChecked(not(checked, leftChecked));

    let newVals = {...formValues};
    newVals["users"]=rightVal;
    setFormValues(newVals);
  };

  const handleCheckedToLeft=()=>{
    let leftVal = [...left, ...rightChecked];
    setLeft(leftVal);
    let rightVal=not(right, rightChecked);
    setRight(rightVal);
    setChecked(not(checked, rightChecked));

    let newVals = {...formValues};
    newVals["users"]=rightVal;
    setFormValues(newVals);
  };

  const handleAllLeft=()=>{
    let newLeft=[...left, ...right];
    setLeft(newLeft);
    setRight([]);
    setChecked(not(checked, rightChecked));
    let newVals = {...formValues};
    newVals["users"]=[];
    setFormValues(newVals);
  };

  const customList = (items) => {
    return (
      <Paper className={classes.paper}>
        <List dense component="div" role="list">
          {items.sort(sortUsers).map((value) => {
            let user=userList[value];
            const labelId = `transfer-list-item-${value}-label`;
            
            return (
              <ListItem key={value} role="listitem" button onClick={handleToggle(value)}>
                <ListItemIcon>
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={user.userAccount} />
              </ListItem>
            );
          })}
          <ListItem />
        </List>
      </Paper>
    )
  };

  return (
    <StyledGrid container spacing={2} justifyContent="center" alignItems="center" className={classes.root}>
      <Grid item>
        <span>Available users:</span>
        {customList(left)}
      </Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleAllRight}
            disabled={left.length === 0}
            aria-label="move all right"
          >
            &gt;&gt;&gt;
          </Button>
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedToRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedToLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleAllLeft}
            disabled={right.length === 0}
            aria-label="move all left"
          >
            &lt;&lt;&lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <span>Users with access:</span>
        {customList(right)}
      </Grid>
    </StyledGrid>
  );
}
UserTransferList.propTypes={
  formValues: PropTypes.object.isRequired,
  setFormValues: PropTypes.func.isRequired,
  userList: PropTypes.object.isRequired,
}